<template>
    <div class="page-tab-container">
        <div class="page-tab">
            <div class="page-tab-options">
                <div class="page-tab-options-left">
                    <div class="page-tab-options-left-title">
                        Altern. 01
                    </div>
                    <widgetDropdown v-model="filterInput.left.showDepartmentDropdown" :right="true" :hover="false"
                        :interactive="true">
                        <button class="btn-dropdown">
                            <span>Departments:{{ filterInput.left.selectedDepartment ? filterInput.left.selectedDepartment :
                                'All' }}</span>
                            <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                        </button>
                        <div slot="dropdown" class="dropdown-widget right">
                            <a class="dropdown-item" href="#" v-for="(item, index) in departments" :key="index"
                                @click="onSelectDepartment(item)">
                                {{ item.name }}</a>
                        </div>
                    </widgetDropdown>
                    <div class="h-spacer"></div>
                    <widgetDropdown :disabled="filterForm.left.selectedDepartment"
                        v-model="filterInput.left.showTeamDropdown" :right="true" :hover="false" :interactive="true">
                        <button class="btn-dropdown">
                            <span>Teams:{{ filterInput.left.selectedTeam ? filterInput.left.selectedTeam : 'All' }}</span>
                            <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                        </button>
                        <div slot="dropdown" class="dropdown-widget right">
                            <a class="dropdown-item" href="#" v-for="(item, index) in filterInput.left.teams" :key="index"
                                @click="onSelectTeam(item)">
                                {{ item.name }}</a>
                        </div>
                    </widgetDropdown>
                </div>
                <div class="page-tab-option-divider">
                    <button class="btn-reverce">
                        <img src="@/assets/matrix/reverse-allow.svg">
                    </button>
                </div>
                <div class="page-tab-options-center">
                    <div class="page-tab-options-center-title">
                        Altern. 02
                    </div>
                    <widgetDropdown v-model="filterInput.right.showDepartmentDropdown" :right="true" :hover="false"
                        :interactive="true">
                        <button class="btn-dropdown">
                            <span>Departments:{{ filterInput.right.selectedDepartment ? filterInput.right.selectedDepartment
                                :
                                'All' }}</span>
                            <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                        </button>
                        <div slot="dropdown" class="dropdown-widget right">
                            <a class="dropdown-item" href="#" v-for="(item, index) in departments" :key="index"
                                @click="onSelectDepartment(item, 'right')">
                                {{ item.name }}</a>
                        </div>
                    </widgetDropdown>
                    <div class="h-spacer"></div>
                    <widgetDropdown :disabled="filterForm.right.selectedDepartment"
                        v-model="filterInput.right.showTeamDropdown" :right="true" :hover="false" :interactive="true">
                        <button class="btn-dropdown">
                            <span>Teams:{{ filterInput.right.selectedTeam ? filterInput.right.selectedTeam : 'All' }}</span>
                            <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
                        </button>
                        <div slot="dropdown" class="dropdown-widget right">
                            <a class="dropdown-item" href="#" v-for="(item, index) in filterInput.right.teams" :key="index"
                                @click="onSelectTeam(item, 'right')">
                                {{ item.name }}</a>
                        </div>
                    </widgetDropdown>
                </div>
                <div v-if="false" class="page-tab-option-divider">
                </div>
                <div v-if="false" class="page-tab-options-right">
                    <div class="page-tab-options-right-title">
                        Search
                    </div>
                    <div class="skills-search-filter-widget">
                        <TagsInput v-model="filterInput.search_query" inputWidth="220px"
                            :icon="require('@/assets/icons/search.svg')" />
                        <widgetButton :loading="loadingMetrics" @click="getMatrixCompare()" class="btn-secondary">
                            Search
                        </widgetButton>
                    </div>
                </div>

            </div>

        </div>

        <div v-if="!loadingMetrics && skillData.length > 0" class="page-body">
            <CompareWidget v-for="(item, index) in skillData" :key="index" :rightData="filterInput.right"
                :leftData="filterInput.left" :title="item.skillSection" :skillData="item">
            </CompareWidget>
        </div>
        <!-- Loading preview -->
        <div class="page-body loading-widget" v-if="loadingMetrics">
            <loading :height="40" :width="40" :active="true" color="#1ba5a4" background-color="#fff"
                :is-full-page="false" />
        </div>

        <div v-if="!loadingMetrics && skillData.length == 0" class="page-body-empty">
            <widgetNotFoundWidget title="Result not Found" content="No result found for your search">
                <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
            </widgetNotFoundWidget>
        </div>
    </div>
</template>
<script>
import { eventBus } from "@/main";
import CompareWidget from "@/views/Matrix/components/CompareWidget.vue"
export default {
    components: {
        CompareWidget
    },
    props: {
    },
    data: () => ({
        filterInput: {
            search_query: {
                added: [],
                removed: []
            },
            left: {
                showTeamDropdown: false,
                selectedTeam: null,
                teams: [
                    {
                        name: "All",
                        value: null,
                    }
                ],
                // Department Dropdown
                showDepartmentDropdown: false,
                selectedDepartment: null,
            },
            right: {
                showTeamDropdown: false,
                selectedTeam: null,
                teams: [
                    {
                        name: "All",
                        value: null,
                    }
                ],
                // Department Dropdown
                showDepartmentDropdown: false,
                selectedDepartment: null,
            }
        },
        departments: [
            {
                name: "All",
                value: null,
            }
        ],
        // Department
        filterForm: {
            skills: [],
            left: {
                location: "",
                selectedDepartment: null,
                selectedTeam: null,
            },
            right: {
                location: "",
                selectedDepartment: null,
                selectedTeam: null,
            },
        },
        loadingMetrics: false,
        skillData: []
    }),
    mounted() {
        let vm = this;
        vm.getAllDepartment();
    },
    computed: {

    },
    watch: {

    },
    methods: {
        getMatrixCompare() {
            let vm = this;
            vm.loadingMetrics = true;
            vm.filterForm.skills = vm.filterInput.search_query.added.map(item => item.name);
            vm.$store
                .dispatch("MATRIX_START_COMPARE_LEFT_DATA", vm.filterForm)
                .then((responce) => {
                    vm.loadingMetrics = false;
                    vm.skillData = responce.data;

                })
                .catch((error) => {
                    vm.loadingMetrics = false;
                    console.error({ error });
                });
        },
        getAllDepartment() {
            let vm = this;
            vm.$store
                .dispatch("GET_ALL_DEPARTMENT")
                .then((responce) => {
                    let initialData = [{
                        name: "All",
                        value: null,
                    }];
                    responce.data.map(item => {
                        return {
                            name: item.name,
                            value: item.id,
                        }
                    }).forEach(item => {
                        initialData.push(item);
                    });
                    vm.departments = initialData;
                })
                .catch((error) => {
                    console.error({ error });
                });
        },
        getDepartmentTeams(type = "left") {
            let vm = this;
            vm.$store
                .dispatch("GET_ALL_DEPARTMENT_TEAMS", {
                    departmentId: type == "left" ? vm.filterForm.left.selectedDepartment : vm.filterForm.right.selectedDepartment
                })
                .then((responce) => {
                    let initialData = [{
                        name: "All",
                        value: null,
                    }];
                    responce.data.map(item => {
                        return {
                            name: item.name,
                            value: item.id,
                        }
                    }).forEach(item => {
                        initialData.push(item);
                    });
                    if (type == "left") {
                        vm.filterInput.left.teams = initialData;
                    } else {
                        vm.filterInput.right.teams = initialData;
                    }
                })
                .catch((error) => {
                    console.error({ error });
                });
        },
        onSelectDepartment(item, type = "left") {
            let vm = this;
            if (type == "left") {
                vm.filterForm.left.selectedDepartment = item.value;
                vm.filterInput.left.selectedDepartment = item.name;
                vm.filterInput.left.showDepartmentDropdown = false;
            } else {
                vm.filterForm.right.selectedDepartment = item.value;
                vm.filterInput.right.selectedDepartment = item.name;
                vm.filterInput.right.showDepartmentDropdown = false;
            }

            vm.getDepartmentTeams(type);
            vm.getMatrixCompare();
        },
        onSelectTeam(item, type = "left") {
            let vm = this;
            if (type == "left") {
                vm.filterForm.left.selectedTeam = item.value;
                vm.filterInput.left.selectedTeam = item.name;
                vm.filterInput.left.showTeamDropdown = false;
            } else {
                vm.filterForm.right.selectedTeam = item.value;
                vm.filterInput.right.selectedTeam = item.name;
                vm.filterInput.right.showTeamDropdown = false;
            }
            vm.getMatrixCompare();
        },
        onFilterByLocation(loc, type = 'left') {
            let vm = this;
            if (type == "left") {
                vm.filterForm.left.location = loc;
            } else {
                vm.filterForm.right.location = loc;
            }
            vm.getMatrixCompare();
        },
    },

};
</script>
  
<style lang="scss" scoped>
.page-tab-container {
    height: calc(100% - 38px);
    display: flex;
    flex-direction: column;

    .page-tab {
        display: flex;
        flex-direction: column;
        height: max-content;
        margin-bottom: 5px;
        border-radius: 5px;

        .page-tab-options {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 32px;
            height: 60px;
            position: relative;

            .page-tab-option-divider {
                width: 5px;
                height: 100%;
                position: relative;

                .btn-reverce {
                    position: absolute;
                    z-index: 999;
                    height: 30px;
                    width: 30px;
                    background: #fff;
                    border: 2px solid #F6F6F6;
                    display: none;
                    align-items: center;
                    justify-content: center;
                    left: -12px;
                    border-radius: 5px;
                    top: -26px;
                }

            }

            .page-tab-options-left {
                display: flex;
                align-items: center;
                position: relative;
                background: #fff;
                height: 100%;
                width: calc(50% - 2.5px);
                padding: 0px 20px;
                border-bottom-right-radius: 5px;
                border-bottom-left-radius: 5px;


                .page-tab-options-left-title {
                    position: absolute;
                    left: 0px;
                    right: 0px;
                    top: -40px;
                    font-family: "Nunito";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    margin: 8px 0px;
                    background: #fff;
                    padding: 8px 19px;
                    border-top-right-radius: 5px;
                    border-top-left-radius: 5px;
                }

                .btn-dropdown {
                    background: #F7F7F7;
                    border-radius: 5px;
                    height: 40px;
                    padding: 0px 10px;
                }
            }

            .page-tab-options-center {
                display: flex;
                align-items: center;
                position: relative;
                background: #fff;
                height: 100%;
                width: calc(50% - 2.5px);
                padding: 0px 20px;
                border-bottom-right-radius: 5px;
                border-bottom-left-radius: 5px;


                .page-tab-options-center-title {
                    position: absolute;
                    left: 0px;
                    right: 0px;
                    top: -40px;
                    font-family: "Nunito";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    margin: 8px 0px;
                    background: #fff;
                    padding: 8px 19px;
                    border-top-right-radius: 5px;
                    border-top-left-radius: 5px;

                }
            }

            .page-tab-options-right {
                display: flex;
                align-items: center;
                position: relative;
                background: #fff;
                height: 100%;
                width: calc(33% - 2.5px);
                padding: 0px 20px;
                border-bottom-right-radius: 5px;
                border-bottom-left-radius: 5px;

                .page-tab-options-right-title {
                    position: absolute;
                    left: 0px;
                    right: 0px;
                    top: -40px;
                    font-family: "Nunito";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    margin: 8px 0px;
                    background: #fff;
                    padding: 8px 19px;
                    border-top-right-radius: 5px;
                    border-top-left-radius: 5px;

                }


                .skills-search-filter-widget {
                    display: flex;

                    .btn-secondary {
                        margin-left: 10px;
                    }
                }
            }
        }
    }


    .page-body {
        height: calc(100% - 100px);
        padding-bottom: 60px;
        position: relative;
        display: grid;
        grid-template-columns: calc(50% - 5px) calc(50% - 5px);
        grid-gap: 5px;
        overflow-y: auto;
    }

    .page-body-empty {
        padding-top: 5px;
        height: calc(100% - 100px);

    }
}
</style>
  